import { FeatureMap } from './models/feature-map';

export class AppConsts {

    //gets loaded from env.js
    static remoteServiceBaseUrl: string = window["injectedURL"] || "http://localhost:21021";
    static appBaseUrl: string = "/home";
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'OACI'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
    };
    static appPath: string;

    //gets loaded from env.js
    static enabledFeatures:FeatureMap = window["enabledFeatures"] ||  {
        app: {
            isProduction: false
        },
        main: {
            farmer: {
                menu: true,
                addNewCertification: true,
                certificationList: true,
            },
            certifications:{
                menu:true,
            },
            farmers:{
                menu:true,
            },
            verifications:{
                menu:true
            },
            users:{
                menu:true
            }
        }
    }

}
